import axios from 'axios';

const Api = () => {
  const getProductsFetch = (): Promise<unknown> => axios.get(`${process.env.REACT_APP_CHECKOUT_URL}products`);

  return { getProductsFetch };
};

export default Api;
